<template lang="pug">
.edit-profile
  .dashboard
    .frow
      .box
        h1.title-call-out Edit Profile
        .frow.justify-between.items-center.dashboard-header
          div
            h3 Welcome, {{ user.name }}
          .frow.row-end
            VButton(
              text="Save"
              @click.native="save()"
            )
            VButton(
              text="Cancel"
              @click.native="cancel"
            )
          // ====== USER INFO ======
        .frow.gutters
          .col-md-1-2
            .field
              label.label.reset Upload a profile picture
              input(type="file" @change="uploadProfilePic")
              Loader(v-if="newPhoto && imgLoading")
              div(v-show="!imgLoading" id="editor" :class="{'editor':true}")
                  img(id="image")
                  VButton(
                    size="small"
                    text="Rotate Left"
                    @click.native="cropper.rotate(-90)")
                  VButton(
                    size="small"
                    text="Rotate Right"
                    @click.native="cropper.rotate(90)")
                  VButton(
                    size="small"
                      text="-"
                    @click.native="cropper.zoom(-0.1)")
                  VButton(
                    size="small"
                    text="+"
                    @click.native="cropper.zoom(0.1)")
            // ====== MENTOR/SKILLSET ======
          .col-md-1-2
            .frow.row-start.mb-25
              .field
                label.label.reset Full Name
                small e.g. Johnmark Beaty
                p.control
                  input(
                    name="name",
                    type="text",
                    v-model="user.name",
                    placeholder="Name",
                  )
          // ====== BIO ======
          .col-md-1-1.mt-25
            .frow.column-start.mb-25
              .col-md-1-1
                .field
                  label.label.reset Bio
                  small Write a little about yourself
                  p.control
                    textarea(
                      name="bio",
                      v-model="user.bio",
                    )
          .frow.p-10.row-start.width-100
            .col-md-1-2
              YesNo(
                name="guide"
                question="Do you want to be a guide?"
                v-model="user.guide"
              )
              div(v-if="userRole === 'admin'")
                YesNo(
                  name="guideApproved"
                  question="Guide Approved"
                  v-model="user.guideApproved"
                )
            .col-md-1-2
              .field(v-if="user.guide === true")
                small Your profile will be submitted for review. Please make sure you have filled out all your information and added a picture.
                br
                small If you have not filled out all information, or have not uploaded a picture, it will not be approved. If it is approved, your profile will go live immediately.
          // ====== TAGS ======
          .col-md-1-1.mt-25(v-if="user.guide === true")
            GuideForm(
              :user.sync="user"
              @save="save()"
            )
            Alert(
              v-if="err"
              :body="`Please click <a href='mailto:johnmarkbeaty@gmail.com?subject=An Error has occured&body=%0A%0A---YOUR MESSAGE ABOVE THIS LINE---%0A%0A---Error DATA---%0A%0A${err} - DATA: ${JSON.stringify(user)}'>here</a> for assistance.`"
            )
          .col-md-1-1.mt-25(v-if="userRole === 'admin'")
            .frow.column-start.mb-25
              .col-md-1-1
                .field
                  label.label.reset EYA Recommendation
                  small Write a discription on why you think this is a quality Guide.
                    br
                    strong NOTE: If there is any text entered in this field it will display on the Guides Profile
                  p.control
                    textarea(
                      name="recommendation",
                      v-model="user.recommendation",
                    )
</template>
<script>
import { mapState } from "vuex";
import Loader from "../components/Loader";
import CropperJS from "cropperjs";
import "cropperjs/dist/cropper.css";
import Multiselect from "vue-multiselect";
import GuideForm from "@/new-components/GuideForm/GuideForm";
import YesNo from "@/new-components/GuideForm/YesNo";
import Alert from "@/new-components/Alert";

export default {
  name: "edit-profile",
  components: {
    Loader,
    Multiselect,
    GuideForm,
    YesNo,
    Alert
  },
  props: {
    userOverride: {
      type: Object
    }
  },
  data: () => ({
    imgLoading: true,
    cropper: {},
    newPhoto: false,
    user: {},
    err: null
  }),
  computed: {
    ...mapState({
      token: state => state.token,
      userRole: state => state.user.role.type
    })
    // tags() {
    //   let tags = JSON.stringify(this.user.tags);
    //   return tags;
    // },
    // tagsArray() {
    //   let tags = this.user.tags;
    //   return tags.toJSON();
    // }
  },
  methods: {
    cancel() {
      if (this.userOverride) {
        this.$emit("close");
      } else {
        this.$router.push("/dashboard");
      }
    },
    save() {
      if (this.newPhoto) {
        this.uploadImage();
      }
      let data = Object.assign({}, this.user);
      // let data = {
      //   name: this.user.name,
      //   bio: this.user.bio,
      //   guide: this.user.guide,
      //   tags: this.user.tags
      // };
      delete data.id;
      delete data.username;
      delete data.email;
      delete data.provider;
      delete data.password;
      delete data.resetPasswordToken;
      delete data.confirmed;
      delete data.blocked;
      delete data.role;
      delete data.created_at;
      delete data.updated_at;
      if (this.userRole !== "admin") {
        delete data.guideApproved;
        delete data.recommendation;
      }
      this.axios
        .put(`${this.$API}/users/${this.user.id}`, data)
        .then(response => {
          if (response.status == 200) {
            if (this.userOverride) {
              this.$emit("close");
            } else {
              this.$router.push("dashboard");
            }
          }
        })
        .catch(err => {
          this.err = err;
        });
    },
    setUpCropper() {
      this.cropper = new CropperJS(document.getElementById("image"), {
        aspectRatio: 1 / 1,
        dragMode: "crop",
        zoomOnTouch: false,
        zoomOnWheel: false
      });
      // this.cropper.replace(this.user.photoUrl);
    },
    uploadProfilePic(e) {
      this.newPhoto = true;
      if (window.FileReader) {
        // this.imgLoading = true;
        let file = e.target.files;
        let reader = new FileReader();
        reader.readAsDataURL(file[0]);

        // reader.onprogress = this.updateProgress;
        reader.onload = this.loaded;
        reader.onerror = this.errorHandler;
      } else {
        alert("FileReader is not supported in your browser )=");
      }
    },
    loaded(evt) {
      this.setUserImage(evt);
      this.cropper.replace(this.user.photoUrl);
    },
    setUserImage(evt) {
      let img = new Image();
      img.src = evt.target.result;
      this.imgLoading = false;
      this.user.photoUrl = img.src;
    },
    uploadImage() {
      this.getCanvasAsBlob().then(blob => {
        const body = new FormData();

        body.append("refId", this.user.id);
        body.append("ref", "user");
        body.append("source", "users-permissions");
        body.append("field", "photo");
        body.append("files", blob);

        const request = new XMLHttpRequest();

        request.open("POST", `${this.$API}/upload`);
        request.setRequestHeader("Authorization", `Bearer ${this.token}`);
        request.send(body);
      });
    },
    getCanvasAsBlob() {
      return new Promise(resolve => {
        this.cropper
          .getCroppedCanvas({
            height: this.resizeHeight,
            width: this.resizeWidth
          })
          .toBlob(
            blob => {
              resolve(blob);
            },
            "image/jpeg",
            0.7
          );
      });
    }
  },
  mounted() {
    this.setUpCropper();
    if (this.userOverride) {
      this.user = this.userOverride;
    } else {
      this.$store.dispatch("getUser");
      this.user = this.$store.getters.user;
    }
    if (this.user.tags) {
      //this.user.tags = JSON.parse(this.user.tags);
      return;
    } else {
      this.user.tags = [];
    }
  }
};
</script>
<style lang="scss">
.edit-profile {
  .box {
    width: 800px;

    h3 {
      font-size: 1.75rem;
    }

    h5 {
      margin-top: 15px;
      font-style: italic;
    }
  }

  #upload {
    border-bottom: none;
    margin: 0;
    padding: 0;
  }

  .dashboard {
    .dashboard-header {
      border-bottom: 1px solid;
      padding: 10px 0;
      margin-bottom: 25px;
    }

    .tag {
      color: #ffffff;
      margin: 5px;
    }
  }

  .theme {
    align-items: flex-start;
    display: flex;
  }

  .user-image {
    width: 100%;
    height: 150px;
    border-radius: 50%;
    max-width: 150px;
    display: block;
    margin: 0 auto;
  }

  .editor {
    img {
      max-width: 100%;
    }
  }

  .cropper-view-box,
  .cropper-face {
    border-radius: 50% !important;
  }
  .guide-question {
    label {
      width: 50px;
    }
  }
}
</style>
